import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"

export const donwloadCSV = (headers: any, rows: any, fileName: string) => {
    const csvContent =
        headers.join(",") + "\n" + rows.map((row: any) => row.map((val: any) => `"${val}"`).join(",")).join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const downloadPDF = (headers: string[], rows: any[][], fileName = "subscriptions") => {
  const doc = new jsPDF()

  // Title
  doc.setFontSize(16)
  doc.text(fileName, 14, 15)

  // Table
  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: 25,
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [41, 128, 185], // blue header
      textColor: 255,
    },
  })

  doc.save(fileName)
}
